import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-client-list',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.css'
})
export class ClientListComponent {

  clients=[
  {
    "id": 1,
    "name": "Anita Sharma",
    "email": "anita.sharma@example.com",
    "phone": "+91-9876543210",
    "company": "Sharma Tech Solutions",
    "address": "201, Green Park, Delhi, India"
  },
  {
    "id": 2,
    "name": "Ravi Patel",
    "email": "ravi.patel@example.com",
    "phone": "+91-9988776655",
    "company": "Patel Enterprises",
    "address": "5th Floor, Orchid Tower, Ahmedabad, Gujarat"
  },
  {
    "id": 3,
    "name": "Priya Nair",
    "email": "priya.nair@example.com",
    "phone": "+91-9123456780",
    "company": "Nair Innovations",
    "address": "102, Palm Grove, Kochi, Kerala"
  },
  {
    "id": 4,
    "name": "Amit Desai",
    "email": "amit.desai@example.com",
    "phone": "+91-9812345678",
    "company": "Desai Digital",
    "address": "Sector 18, Noida, Uttar Pradesh"
  },
  {
    "id": 5,
    "name": "Sneha Kulkarni",
    "email": "sneha.kulkarni@example.com",
    "phone": "+91-9765432109",
    "company": "Kulkarni Group",
    "address": "Baner Road, Pune, Maharashtra"
  },
  {
    "id": 6,
    "name": "Vikram Singh",
    "email": "vikram.singh@example.com",
    "phone": "+91-9345612398",
    "company": "Singh Infra",
    "address": "MG Road, Bengaluru, Karnataka"
  },
  {
    "id": 7,
    "name": "Neha Mehta",
    "email": "neha.mehta@example.com",
    "phone": "+91-9988123412",
    "company": "Mehta Marketing",
    "address": "Lalpur, Ranchi, Jharkhand"
  },
  {
    "id": 8,
    "name": "Rajeev Reddy",
    "email": "rajeev.reddy@example.com",
    "phone": "+91-9004567812",
    "company": "Reddy Solutions",
    "address": "Banjara Hills, Hyderabad, Telangana"
  },
  {
    "id": 9,
    "name": "Kavita Das",
    "email": "kavita.das@example.com",
    "phone": "+91-9098987878",
    "company": "Das Events",
    "address": "Salt Lake City, Kolkata, West Bengal"
  },
  {
    "id": 10,
    "name": "Arjun Verma",
    "email": "arjun.verma@example.com",
    "phone": "+91-9833221100",
    "company": "Verma Retail",
    "address": "Powai, Mumbai, Maharashtra"
  }
]


}
